import { render, staticRenderFns } from "./ExercisedFor.vue?vue&type=template&id=fe13031a&scoped=true&"
import script from "./ExercisedFor.vue?vue&type=script&lang=js&"
export * from "./ExercisedFor.vue?vue&type=script&lang=js&"
import style0 from "./ExercisedFor.vue?vue&type=style&index=0&id=fe13031a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe13031a",
  null
  
)

export default component.exports